"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialLoyaltyValues = exports.tableColumns = void 0;
var utils_1 = require("@doshexchnage/utils");
exports.tableColumns = [
    {
        displayKey: "loyalty_number",
        label: "Loyalty Number",
        formatter: function (_) { var _a; return (_a = _ === null || _ === void 0 ? void 0 : _.card) === null || _a === void 0 ? void 0 : _a.number; },
    },
    {
        displayKey: "loyalty_number",
        label: "Loyalty Card Number",
    },
    {
        displayKey: "linked",
        label: "Card Linked",
        formatter: function (_) { var _a; return (((_a = _ === null || _ === void 0 ? void 0 : _.card) === null || _a === void 0 ? void 0 : _a.linked) ? "Yes" : "No"); },
    },
    {
        displayKey: "member_date",
        label: "Date Activated",
        formatter: function (_) { return utils_1.Formatting.formatDateTime(_ === null || _ === void 0 ? void 0 : _.member_date); },
    },
    {
        displayKey: "customer",
        label: "Customer",
        formatter: function (_) { var _a, _b; return "".concat((_a = _ === null || _ === void 0 ? void 0 : _.user) === null || _a === void 0 ? void 0 : _a.name, " ").concat((_b = _ === null || _ === void 0 ? void 0 : _.user) === null || _b === void 0 ? void 0 : _b.surname); },
    },
];
exports.initialLoyaltyValues = {
    member_date: utils_1.Formatting.formatDateTime(new Date(), "yyyy-MM-dd"),
    loyalty_number: "",
    card: {
        number: "",
        linked: false,
    },
};
